import { useContext } from "react";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import logo from "../assets/small-logo.png";

export default function Footer() {
  const appContext = useContext(AppContext);

  const footerLinks = [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about_us" },
    { label: "Products", item: "products" },
    { label: "Portfolio", item: "gallery" },
    { label: "Contact", item: "contact_us" },
  ];

  const services = ["Printing", "Branding", "Packaging", "Merchandise"];

  function goTo(item) {
    appContext.navTo({
      item,
    });
  }

  return (
    <footer className="footer-outer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src={logo} alt="Esmeriser" className="footer-logo" />
            <p>
              Creative printing and branding for businesses, events, products,
              and everyday promotions.
            </p>
          </div>

          <div className="footer-panel">
            <h6 className="footer-heading">Explore</h6>
            <nav className="footer-nav" aria-label="Footer navigation">
              {footerLinks.map((link) => (
                <button
                  type="button"
                  className="footer-link"
                  key={link.label}
                  onClick={() => goTo(link.item)}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="footer-panel">
            <h6 className="footer-heading">Services</h6>
            <div className="footer-services" aria-label="Popular services">
              {services.map((service) => (
                <span key={service}>{service}</span>
              ))}
            </div>
          </div>

          <div className="footer-panel footer-contact">
            <h6 className="footer-heading">Contact</h6>
            <a className="footer-contact-link" href="tel:+255717515036">
              <MdPhone size={18} />
              <span>+255 717 515 036</span>
            </a>
            <a className="footer-contact-link" href="mailto:info@esmeriser.co.tz">
              <MdEmail size={18} />
              <span>info@esmeriser.co.tz</span>
            </a>
            <div className="footer-contact-link">
              <MdLocationOn size={18} />
              <span>Mbuyuni, near Namanga, Manara Street, Gate No. 32</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {getCurrentYear()} Esmeriser Investment.</span>
          <span>
            Website developed by{" "}
            <a
              href="https://werenium.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Werenium Technologies
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
